var InputBase = require('../base');

var CheckBox = InputBase.extend( {
    /*
    @inputOption = {
        options: 'val1:name1;val2:name;val3:name3',
        multi: true,
        float: true,
        hightlightSelected: false
    }
    */
    create: function( inputOptions, $container ) {
        var self = this
        self.inputOptions = inputOptions;
        if (inputOptions.valuePairs && inputOptions.valuePairs.match(/[^:]+:[^:]+/)) {
            self.valuePairs = inputOptions.valuePairs.replace(/\s/g, '').split(':');
        } else {
            self.valuePairs = ['Y', 'N'];
        }
        self.$inp = $('<span>').addClass('ui-widget-content')
            .appendTo($container);

        self.$inp.on('click', function() {
            if ($(this).prop('checked')) {
                $(this).prop('checked', false)
                    .removeClass('fa fa-check');
            } else {
                $(this).prop('checked', true)
                    .addClass('fa fa-check');
            }
            self.trig('Check');
            self.trig('Focus');
        });
        return self.$inp;
    },
    getValue: function() {
        return this.$inp.prop('checked') ? this.valuePairs[0] : this.valuePairs[1];
    },
    setValue: function( value ) {
        if (value === this.valuePairs[0]) {
            this.$inp.prop('checked', true)
                .addClass('fa fa-check');
        } else {
            this.$inp.prop('checked', false)
                .remove('fa fa-check')
        }
        return this;
    }
} );

module.exports = CheckBox;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/checkbox/index.js
// module id = 18
// module chunks = 0